import { FormGroup } from '@angular/forms';

export class PrimecapUtils {
  public static calcularDias(data: Date) {
    let dataAtual = new Date();
    let dataFinal = new Date(data);
    dataFinal.setDate(dataFinal.getDate());
    let diferencaInTime = dataAtual.getTime() - dataFinal.getTime();
    let dias = Math.floor(diferencaInTime / (1000 * 3600 * 24));
    return dias;
  }

  public static verificarPermissoesUsuario(permissoesRota: string[], permissoesUsuario: string[]) {
    for (let permissaoRota of permissoesRota) {
      if (permissoesUsuario?.includes(permissaoRota)) {
        return true;
      }
    }

    return false;
  }

  public static transformarValorEmPorcentagem(dividendo: number,divisor: number): number {
    let porcentagem = Math.trunc((dividendo / divisor) * 100);
    return porcentagem;
  }

  public static dividirValorPorCem(valor: number): number | null {
    if (valor) {
      return valor / 100;
    } else {
      return null;
    }
  }

  public static multiplicarValorPorCem(valor: number): number | null {
    if (valor) {
      return valor * 100;
    } else {
      return null;
    }
  }

  public static exibirLinkDocumento(formGroup: FormGroup, campoForm: string) {
    let valorCampoForm = formGroup.get(campoForm).value;
    if (valorCampoForm == 'null') {
      return null;
    } else {
      return formGroup.get(campoForm).value;
    }
  }
}
